module.exports = __webpack_public_path__ + "media/login_ok.bd4dd9a6.wav";